/**
 * Extracts a string from a locale object or returns the string directly
 * @param value - Either a string or an object with locale keys like {en: "English", de: "German"}
 * @param fallback - Fallback value if no valid string is found
 * @param preferredLocale - Preferred locale to extract (defaults to 'en')
 * @returns The extracted string
 */
export function getLocalizedString(
  value: string | Record<string, string> | null | undefined,
  fallback: string = '',
  preferredLocale: string = 'en'
): string {
  if (!value) return fallback;

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object') {
    // Try preferred locale first
    if (value[preferredLocale]) {
      return value[preferredLocale];
    }

    // Try English as backup
    if ('en' in value && value['en']) {
      return value['en'];
    }

    // Try first available locale
    const keys = Object.keys(value);
    if (keys.length > 0) {
      const firstKey = keys[0];
      if (firstKey && value[firstKey]) {
        return value[firstKey];
      }
    }
  }

  return fallback;
}